import { AppPageHeader } from './AppPageHeader';
import { runtime } from '../../runtime/Runtime';
export class AppPage {
    parent;
    header = new AppPageHeader(this);
    constructor(parent) {
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get hasEditGetParameter() {
        return (runtime.isBrowserRuntime && ['1', '2'].includes(runtime.solidBrowserRuntime.browserAddressBar.query.edit));
    }
    get hasPreviewGetParameter() {
        return runtime.isBrowserRuntime && runtime.solidBrowserRuntime.browserAddressBar.query.preview === '1';
    }
    get manualQuestionId() {
        if (!runtime.isBrowserRuntime)
            return undefined;
        const id = runtime.solidBrowserRuntime.browserAddressBar.query.questionId;
        if (!id)
            return undefined;
        return parseInt(id);
    }
}
